import styles from './Spinner.module.css';

type Props = {
  size?: number;
  color?: string;
  /** Centres the spinner in a tall block — used for full-page loading. */
  block?: boolean;
  label?: string;
};

export default function Spinner({ size = 26, color = 'var(--brand-press)', block, label }: Props) {
  const spinner = (
    <span
      className={styles.spinner}
      style={{ width: size, height: size, borderColor: color, borderTopColor: 'transparent' }}
      role="status"
      aria-label={label ?? 'Chargement'}
    />
  );

  if (!block) return spinner;

  return (
    <div className={styles.block}>
      {spinner}
      {label ? <p className={styles.label}>{label}</p> : null}
    </div>
  );
}
